import { Navigate } from 'react-router-dom';
import { useJobDescriptionAuth } from './JobDescAuthProvider';

const JobDescPrivateRoute = ({ children }) => {
  const { isJobDescAuthenticated } = useJobDescriptionAuth();
  if (!isJobDescAuthenticated) {
    // If not authenticated, redirect to login page
    return <Navigate to="/jobdescription/jobdescriptionUtility" />;
  }

  // If authenticated, render the children (protected route content)
  return children;
};

export default JobDescPrivateRoute;
